module.exports = __webpack_public_path__ + "static/media/JQuery.aa3d8ce8.png";